module.exports = __webpack_public_path__ + "img/gluten.5eed3def.svg";